import { render, staticRenderFns } from "./ontick-plan-logo.component.vue?vue&type=template&id=76fc8d8d&scoped=true"
import script from "./ontick-plan-logo.component.vue?vue&type=script&lang=js"
export * from "./ontick-plan-logo.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-plan-logo.component.vue?vue&type=style&index=0&id=76fc8d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fc8d8d",
  null
  
)

export default component.exports